"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieOutroBase = _interopRequireDefault(require("../../LottieOutroBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Outro04 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Outro04, _AnimationBase);

  var _super = _createSuper(Outro04);

  function Outro04(animObj) {
    var _this;

    _classCallCheck(this, Outro04);

    var animationId = animObj.animationId,
        data = animObj.data,
        cdn = animObj.cdn;
    var config = {
      default: {
        colors: ['#ffffff', 'rgb(230, 20, 50)']
      },
      inputs: ['action_01', 'action_02', 'phone', 'disclaimer'],
      width: 1280,
      height: 720,
      fNameToReplace: ['FjallaOne-Regular'],
      inDuration: 2000,
      intermissionDuration: 3000,
      outDuration: 0,
      totalDuration: 5000
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // replace with color 1

    var fontOneColorPattern = new RegExp('"fc":\\[0,1,0]', 'g'); // replace with color 2

    var shapeColorPattern = new RegExp('\\[0.901960784314,0.078431372549,0.196078431373,1]', 'g');
    animation = animation.replace(fontOneColorPattern, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern, "[".concat(_this.colors[1], "]"));
    animation = _this._setInputs(animation, data, config.inputs);
    animation = _this._setPackshot(animation, data, cdn);
    _this.json = JSON.parse(animation);
    return _this;
  }

  return Outro04;
}(_LottieOutroBase.default);

exports.default = Outro04;